import {
  getTokensFromLocalStorage,
  saveTokensToLocalStorage,
} from "../Utility/AccessAndRefreshTokenStorage";

const baseURL = `${process.env.REACT_APP_BACKEND_HOSTED_ON}`;

export function fetchInterceptors(endPoint, method, body, customHeaders = {}) {
  return new Promise((resolve, reject) => {
    const fetchWithRetries = (retryCount) => {
      fetch(baseURL + endPoint, {
        method: method,
        mode: "cors",
        body: JSON.stringify(body),
        headers: {
          ...customHeaders, // Spread the custom headers
          accesstoken: getTokensFromLocalStorage().accessToken,
          refreshtoken: getTokensFromLocalStorage().refreshToken,
          "Content-type": "application/json; charset=UTF-8",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            resolve(response.json());
          } else if (response.status === 401 && retryCount > 0) {
            // Token renewal logic
            fetch(baseURL + "/user/token/accessTokenRenewal", {
              method: "POST",
              headers: {
                accesstoken: getTokensFromLocalStorage().accessToken,
                refreshtoken: getTokensFromLocalStorage().refreshToken,
              },
            })
              .then((renewalResponse) => {
                return renewalResponse.json();
              })
              .then((renewalData) => {
                if (renewalData.code === 200) {
                  const { refreshToken } = getTokensFromLocalStorage();
                  const newAccessToken = renewalData.msg.accessToken;
                  saveTokensToLocalStorage(newAccessToken, refreshToken, true);
                  fetchWithRetries(retryCount - 1);
                }
                if (renewalData.code === 401) {
                  resolve(renewalData);
                  console.log(renewalData);
                }
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve(response.json());
            // reject(new Error("Request failed: " + response.statusText));
          }
        })
        .catch((error) => {
          reject(error);
        });
    };

    fetchWithRetries(1); // Specify the number of retries you want
  });
}
